var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalesCenterActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30939 7.7922C2.43379 6.23281 3.73555 5.03076 5.29989 5.03076H22.6875C24.2518 5.03076 25.5536 6.23281 25.678 7.7922L27.2837 27.9212C27.423 29.6666 26.0441 31.1598 24.2932 31.1598H3.69416C1.94325 31.1598 0.564428 29.6666 0.703659 27.9212L2.30939 7.7922Z",
    fill: "url(#paint0_linear_3_4310)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8004 6.96612C19.8004 3.7593 17.2008 1.15967 13.994 1.15967C10.7871 1.15967 8.1875 3.7593 8.1875 6.96612",
    stroke: "#A74B00",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6135 12.9755C13.7333 12.607 14.2546 12.607 14.3744 12.9755L15.2078 15.5405C15.2613 15.7053 15.4149 15.8168 15.5882 15.8168H18.2851C18.6726 15.8168 18.8337 16.3127 18.5203 16.5405L16.3384 18.1257C16.1982 18.2275 16.1395 18.4081 16.1931 18.5729L17.0265 21.1378C17.1462 21.5064 16.7244 21.8128 16.4109 21.5851L14.2291 19.9998C14.0889 19.898 13.899 19.898 13.7588 19.9998L11.577 21.5851C11.2635 21.8128 10.8417 21.5064 10.9614 21.1378L11.7948 18.5729C11.8484 18.4081 11.7897 18.2275 11.6495 18.1257L9.46765 16.5405C9.15416 16.3127 9.31527 15.8168 9.70276 15.8168H12.3997C12.573 15.8168 12.7266 15.7053 12.7801 15.5405L13.6135 12.9755Z",
    fill: "#FFF6E1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_4310",
    x1: 13.9937,
    y1: 5.03076,
    x2: 13.9937,
    y2: 31.1598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB36D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesCenterActive);
export default "https://c.d2cgo.com/dtc_center/v19/assets/static/media/salesCenter_active.2d45ed24b3e6411f12fd892cc8556fe7.svg";
export { ForwardRef as ReactComponent };